

(function carouselCard () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "carousel-card";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

    $(() => {
      const configDesktop = 3;
      const configTablet = 2;
      const configMobile = 1;

      const splide = new Splide('.splide.carousel-card__slider', {
        perPage: configDesktop,
        perMove: configDesktop,
        gap: '1.5rem',
        easing: 'ease-out',
        omitEnd: true,
        breakpoints: {
          1024: {
            perPage: configTablet,
            perMove: configTablet,
            arrows: false
          },
          768: {
            perPage: configMobile,
            perMove: configMobile,
            arrows: false,
            gap: '1rem'
          }
        },
        i18n: {
          prev: "Afficher la diapo précédente",
          next: "Afficher la diapo suivante",
          slideX: "Aller à la diapo %s",
          carousel: "carrousel",
          slide: "diapo",
          select: "Sélectionner une diapo à afficher",
          slideLabel: "%s sur %s"
        }
      });

       splide.on('pagination:updated', (data) => {
        data.items.forEach((item, index) => {
          let perPage = window.innerWidth >= 1024 ? configDesktop : window.innerWidth >= 560 ? configTablet : configMobile;
          let start = index * perPage + 1;
          let end = Math.min(start + perPage - 1, splide.length);

          item.button.ariaLabel = `Afficher les avis clients ${start} à ${end}`;
          item.button.ariaCurrent = item.button.ariaSelected;
          item.button.tabIndex = 0;
        });
      });


        splide.on('move', (index) => {
           splide.Components.Slides.forEach((item) => {
                let element = item.slide.querySelector('.carousel-card__card-body-title');
                element.removeAttribute("tabindex");
            }); 

                        let currentSlide = splide.Components.Slides.getAt(index);
            let currentTitle = currentSlide.slide.querySelector('.carousel-card__card-body-title');
            currentTitle.tabIndex = 0;
            currentTitle.focus();
      });


                 splide.mount();


           if ( splide.state.is( Splide.STATES.IDLE ) ) {
        const { Elements } = splide.Components;
        Elements.list.removeAttribute('role');
        Elements.slides.forEach( function ( item ) {
              item.removeAttribute('role');
            });
      }

          })
  })()